// extracted by mini-css-extract-plugin
module.exports = {"button":"HamburgerButton_button__jgt1x","menuIcon":"HamburgerButton_menuIcon__czygG"};